import { velocityPerSecond as c } from "./atoms-v2973.js";
const n = 5;
function i(t, o, r) {
  const e = Math.max(o - n, 0);
  return c(r - t(e), o - e);
}
export {
  i as calcGeneratorVelocity
};
